import React, { Fragment } from 'react'
import PropTypes from 'prop-types'

import Box from 'components/_new/layout/Box/Box'
import Text from 'components/_new/typography/Text/Text'

import messages from './messages'
import s from './FooterCopyright.scss'


const year = new Date().getFullYear()

const FooterCopyright = (_props, { globals: { device: { isMobile } } }) =>
  isMobile ? (
    <Box mt="24">
      <Text size="14-24" html muted message={{ ...messages.copyrights, values: { year } }} />
      <Text className={s.madeWith} size="14-24" html message={messages.madeWith} />
    </Box>
  ) : (
    <Fragment>
      <Text className={s.madeWith} size="14-24" html message={messages.madeWith} />
      <Text size="14-24" html muted message={{ ...messages.copyrights, values: { year } }} />
    </Fragment>
  )

FooterCopyright.contextTypes = {
  globals: PropTypes.object.isRequired,
}


export default FooterCopyright
